import useDiscloserHook from '../app/features/settings/discloser/discloser.hook';
import useFiltersHook from '../app/features/settings/filters/filters.hook';
import useSelectionOptionsHook from './useSelectionOptions';

export const useAppFilters = useFiltersHook;
export const useAppDiscloser = useDiscloserHook;
export const useSelectionOptions = useSelectionOptionsHook;

export default { useAppDiscloser, useAppFilters, useSelectionOptions };
